import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
import { isTenantDomain } from 'src/utils/domainContext';
// components
import Logo from 'src/components/logo';

// ----------------------------------------------------------------------

export default function AuthModernLayout({ children, image }) {
  const upMd = useResponsive('up', 'md');
  const tenantDomain = isTenantDomain();

  const renderBrandLockup = (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={1.5}
      sx={{
        mt: { xs: 2, md: 8 },
        mb: { xs: 4, md: 6 },
        flexWrap: 'wrap',
      }}
    >
      <Logo
        disabledLink
        sx={{
          width: tenantDomain ? 180 : 170,
          maxWidth: '100%',
          height: 'auto',
          display: 'block',
        }}
      />

      {tenantDomain && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.75}
          sx={{
            px: 1.5,
            py: 0.75,
            borderRadius: 999,
            border: '1px solid rgba(15, 23, 42, 0.08)',
            backgroundColor: 'rgba(255,255,255,0.85)',
            boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
          }}
        >
          <Box
            component="img"
            src="/assets/MeruDeskShort.png"
            alt="MeruDesk"
            sx={{ width: 22, height: 22, objectFit: 'contain' }}
          />
          <Box component="span" sx={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.4, color: 'text.primary' }}>
            Powered by MeruDesk
          </Box>
        </Stack>
      )}
    </Stack>
  );

  const renderContent = (
    <Stack
      sx={{
        width: 1,
        mx: 'auto',
        maxWidth: 480,
        px: { xs: 2, md: 8 },
      }}
    >
      {renderBrandLockup}

      <Card
        sx={{
          py: { xs: 5, md: 0 },
          px: { xs: 3, md: 0 },
          boxShadow: { md: 'none' },
          overflow: { md: 'unset' },
          bgcolor: { md: 'background.default' },
        }}
      >
        {children}
      </Card>
    </Stack>
  );

  const renderSection = (
    <Stack flexGrow={1} sx={{ position: 'relative' }}>
      <Box
        component="img"
        alt="auth"
        src={image || '/assets/background/overlay_3.jpg'}
        sx={{
          top: 16,
          left: 16,
          objectFit: 'cover',
          position: 'absolute',
          width: 'calc(100% - 32px)',
          height: 'calc(100% - 32px)',
        }}
      />
    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: '100vh',
        position: 'relative',
        '&:before': {
          width: 1,
          height: 1,
          zIndex: -1,
          content: "''",
          position: 'absolute',
          backgroundSize: 'cover',
          opacity: { xs: 0.24, md: 0 },
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundImage: 'url(/assets/background/overlay_4.jpg)',
        },
      }}
    >
      {renderContent}

      {upMd && renderSection}
    </Stack>
  );
}

AuthModernLayout.propTypes = {
  children: PropTypes.node,
  image: PropTypes.string,
};
